export default __webpack_public_path__ + "static/media/FincantieriSI_ZEUSProject.8cf330b3.pdf";